(function () {
  'use strict';

  const angular = window.angular;

  HomeController.$inject = ['$uibModal', '$state', '$http', 'LoopBackAuth', '$rootScope', 'Sensor'];

  const RANGE_HOURS = {
    hour: 1,
    day: 24,
    week: 24 * 7,
  };

  angular.module('app').component('memberHome', {
    template:'<div class="page-header"><h1 class="no-margin" style="border-bottom: 0"><i class="fas fa-home fa-fw"></i> <span class="header-text"><span translate>general.welcome</span> {{$ctrl.user.name}}</span></h1><div class="container"><ul class="nav nav-tabs nav-justified"><li ui-sref-active="active"><a ui-sref="member.home.vars" translate>entities.organization.var.modelNamePl</a></li><li ui-sref-active="active"><a ui-sref="member.home.configs" translate>entities.user.others.globalConfigs</a></li></ul></div></div><div class="container"><ui-view></ui-view></div><hr class="marginT0"><div class="container"><div class="panel panel-default" ng-style="{minHeight: $ctrl.spammingSensorsLoading? \'300px\' : \'auto\', position: relative}"><div class="panel-heading"><h2 class="nowrap"><span translate>member.home.spammingSensorsTitle</span> <i class="fas fa-fw fa-info-circle" style="font-size: 80%; vertical-align: super" uib-tooltip="{{\'member.home.spammingSensorsInfo\' | translate}}" tooltip-placement="bottom"></i></h2><div class="panel-toolbar pull-right"><div class="btn-group btn-group-sm"><button class="btn btn-default" ng-class="{active: $ctrl.activeRange === \'hour\'}" ng-click="$ctrl.setRange(\'hour\')" translate>member.home.rangeLastHour</button> <button class="btn btn-default" ng-class="{active: $ctrl.activeRange === \'day\'}" ng-click="$ctrl.setRange(\'day\')" translate>member.home.rangeLastDay</button> <button class="btn btn-default" ng-class="{active: $ctrl.activeRange === \'week\'}" ng-click="$ctrl.setRange(\'week\')" translate>member.home.rangeLastWeek</button></div></div></div><spinner show="$ctrl.spammingSensorsLoading"></spinner><div class="alert alert-warning no-margin" ng-if="$ctrl.spammingSensorsLoadError" translate>member.home.spammingSensorsLoadError</div><div class="alert alert-info no-margin" ng-if="!$ctrl.spammingSensorsLoading && !$ctrl.spammingSensorsLoadError && $ctrl.spammingSensorsTotal === 0" translate>member.home.noSpammingSensors</div><div class="table-responsive" ng-if="!$ctrl.spammingSensorsLoading && !$ctrl.spammingSensorsLoadError && $ctrl.spammingSensorsTotal > 0"><table class="table table-hover"><thead><tr><th translate>entities.sensor.modelName</th><th translate>entities.asset.modelName</th><th translate>entities.organization.customer.modelName</th><th class="text-center" translate>member.home.spamSummariesCount</th><th></th></tr></thead><tbody><tr ng-repeat="sensor in $ctrl.spammingSensors track by sensor.id"><td>{{sensor.name}}</td><td>{{sensor.assetName}}</td><td>{{sensor.customerName}}</td><td class="text-center">{{sensor.spamSummariesCount}}</td><td class="text-right"><button class="btn btn-xs btn-default" uib-tooltip="{{\'member.home.viewHours\' | translate}}" tooltip-placement="bottom" tooltip-append-to-body="true" ng-click="$ctrl.showSensorHours(sensor)"><i class="fas fa-clock fa-fw"></i></button> <button class="btn btn-xs btn-default" uib-tooltip="{{\'member.home.goToContextualization\' | translate}}" tooltip-placement="bottom" ng-disabled="!$ctrl.canGoToSensorContextualization(sensor)" tooltip-append-to-body="true" ng-click="$ctrl.goToSensorContextualization(sensor)"><i class="fas fa-link fa-fw"></i></button></td></tr></tbody></table></div></div></div>',
    controller: HomeController,
    bindings: {
      user: '<',
      vars: '<',
      spammingSensorsData: '<',
    },
  });

  function HomeController($uibModal, $state, $http, LoopBackAuth, $root, Sensor) {
    let vm = this;

    vm.activeRange = 'day';

    vm.$onInit = function () {
      $root.varId = undefined;
      applySpammingSensorsData(vm.spammingSensorsData);
    };

    let latestRequestId = 0;

    vm.setRange = function (range) {
      if (!RANGE_HOURS[range] || vm.activeRange === range) {
        return;
      }
      vm.activeRange = range;
      loadSpammingSensors(range);
    };

    function loadSpammingSensors(range) {
      const requestId = ++latestRequestId;
      const now = new Date();
      let from;
      let to;

      if (range === 'hour') {
        // "última hora" = the last complete hour, not a rolling 60 minutes,
        // so it doesn't show a partial/still-updating in-progress hour.
        to = new Date(now);
        to.setMinutes(0, 0, 0);
        from = new Date(to.getTime() - RANGE_HOURS.hour * 60 * 60 * 1000);
      } else {
        to = now;
        from = new Date(now.getTime() - RANGE_HOURS[range] * 60 * 60 * 1000);
      }

      const where = { from: { gte: from.toISOString(), lt: to.toISOString() } };

      vm.spammingSensorsLoading = true;
      vm.spammingSensorsLoadError = false;
      vm.spammingSensorsTotal = 0;
      vm.spammingSensors = [];

      Sensor.spamming({ where }).$promise
        .then((response) => {
          // Ignore stale responses: if the user clicked another range button
          // before this one came back, a newer request already superseded it.
          if (requestId !== latestRequestId) {
            return;
          }
          applySpammingSensorsData(response);
        })
        .catch((err) => {
          if (requestId !== latestRequestId) {
            return;
          }
          console.error('Failed to load spamming sensors', err);
          applySpammingSensorsData({ total: 0, sensors: [], loadError: true });
        })
        .finally(() => {
          if (requestId === latestRequestId) {
            vm.spammingSensorsLoading = false;
          }
        });
    }

    function applySpammingSensorsData(data) {
      vm.spammingSensorsData = data;
      vm.spammingSensors = (data && data.sensors) || [];
      vm.spammingSensorsTotal = (data && data.total) || 0;
      vm.spammingSensorsLoadError = !!(data && data.loadError);
    }

    vm.canGoToSensorContextualization = function (sensor) {
      return !!(sensor.varId && sensor.customerId && sensor.projectId && sensor.assetId);
    };

    vm.goToSensorContextualization = function (sensor) {
      if (!vm.canGoToSensorContextualization(sensor)) {
        console.error('Missing data to navigate to sensor contextualization', sensor);
        return;
      }
      $state.go('member.var.show.customer.show.project.contextualization.assets', {
        varId: sensor.varId,
        customerId: sensor.customerId,
        projectId: sensor.projectId,
        assetId: sensor.assetId,
        tab: 'sensor',
      });
    };

    vm.showSensorHours = function (sensor) {
      $uibModal.open({
        animation: true,
        backdrop: true,
        template:
          '<div class="modal-header" style="position: relative;">' +
          '  <button class="close" style="position: absolute; top: 10px; right: 15px;" ng-click="$ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button>' +
          '  <h4 class="modal-title" style="margin-top: 15px;">{{$ctrl.sensor.name}}</h4>' +
          '</div>' +
          '<div class="modal-body">' +
          '  <p class="text-muted" ng-if="$ctrl.sensor.hours.length" translate>member.home.spammedHoursHint</p>' +
          '  <ul class="list-unstyled">' +
          '    <li ng-repeat="hour in $ctrl.sensor.hours">{{hour | date:\'dd/MM/yyyy HH:mm\'}}</li>' +
          '  </ul>' +
          '  <p ng-if="!$ctrl.sensor.hours.length" translate>member.home.noSpammedHours</p>' +
          '</div>',
        controller: [
          '$uibModalInstance',
          'sensor',
          function ($uibModalInstance, sensor) {
            this.sensor = sensor;
            this.modalInstance = $uibModalInstance;
          },
        ],
        controllerAs: '$ctrl',
        resolve: {
          sensor: function () {
            return sensor;
          },
        },
      });
    };
  }
})();
